















































































































import { Component, Prop } from 'vue-property-decorator';
import CartView from './CartView.vue';
import { UpSellListItem } from '@/models/Product';
import UpSellProductListing from './UpSellProductListing.vue';
@Component({
    components: {
        CartView,
        UpSellProductListing
    }
})
export default class CartViewB2C extends CartView {
    [x: string]: any;
    @Prop() hasCampaignVoucherEnabled!: boolean;
    @Prop() upsellProducts!: UpSellListItem[];
    @Prop() showSummary!: boolean;
    @Prop() deliveryCostPageUrl!: string;
    @Prop() deliveryTimeText!: string;

    constructor() {
        super();
    }

    get fullDeliveryTimeText() {
        return this.deliveryTimeText + ' ' + this.cart.deliveryTime;
    }

    mounted(): void {
        if (this.showSummary) {
            if (this.cart.items && this.cart.items.length > 0) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event: 'begin_checkout',
                    ecommerce: {
                        currency: this.cart.currency,
                        value: this.cart.cartTotal,
                        items: this.cart.items
                    }
                });
            }
        }
    }
}
